if (!customElements.get('hoculus-cart-discounts')) {

  customElements.define(
    'hoculus-cart-discounts',
    class HoculusCartDiscounts extends HTMLElement {

      constructor() {
        super();

        this.input = this.querySelector('[data-js-discount-input]');
        this.form = this.querySelector('.cart__discount-codes-form');
        this.cartDiscountError = this.querySelector('[data-js-discount-error]');
        this.cartDiscountSuccess = this.querySelector('[data-js-discount-success]');
        this.discountCodes = this.querySelector('[data-js-discount-codes]');

        if (this.form) {
          this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.applyDiscount();
          });
        }
        this.loadDiscounts();
      }

      applyDiscount() {
        const code = this.input.value.trim().toUpperCase();
        if (!code) return;

        const existingDiscounts = Array.from(
          this.querySelectorAll('[data-js-discount]')
        ).map(el => el.dataset.jsDiscount);

        const allDiscounts = [...new Set([...existingDiscounts, code])];

        fetch(`${window.theme.routes.cart_update_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ discount: allDiscounts.join(',') })
        })
          .then(res => res.json())
          .then(res => {
            const matchingCode = (res.discount_codes || []).find(
              d => d.code.toUpperCase() === code
            );
            if (matchingCode && matchingCode.applicable) {
              this.handleSuccess();
              this.handleSuccessMessage();
            } else {
              this.handleError();
            }
          })
          .catch(() => this.handleError());
      }

      handleSuccess() {
        this.input && (this.input.value = '');
        this.cartDiscountError && this.cartDiscountError.classList.remove('show');
        this.cartDiscountSuccess && this.cartDiscountSuccess.classList.remove('show');

        fetch(window.theme.routes.cart_url + '?section_id=api-cart-items')
          .then(res => res.text())
          .then(html => {
            const element = document.createElement('div');
            element.innerHTML = html;
            const cleanResponse = element.querySelector('[data-api-content]');
            if (cleanResponse && window.cart) {
              window.cart.build(cleanResponse);
            }
          })
          .then(() => this.loadDiscounts())
          .catch(err => console.log(err));
      }

      onRemoveDiscounts() {
        this.querySelectorAll('[data-js-discount]').forEach(el => {
          if (el.classList.contains('enabled')) return;
          el.classList.add('enabled');

          el.addEventListener('click', () => {
            const discountToRemove = el.dataset.jsDiscount;
            const allDiscounts = Array.from(this.querySelectorAll('[data-js-discount]'))
              .map(el => el.dataset.jsDiscount)
              .filter(d => d !== discountToRemove);

            fetch(`${window.theme.routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ discount: allDiscounts.join(',') })
            }).then(() => {
                this.handleSuccess();
            });
          });
        });
      }

      loadDiscounts() {
        if (!this.discountCodes) return;
        fetch('/cart?section_id=hoculus-api-discount-items')
          .then(res => res.text())
          .then(html => {
            const element = document.createElement('div');
            element.innerHTML = html;
            const discountCodesEl = element.querySelector('[data-js-discount-codes]');
            if (discountCodesEl) {
              this.discountCodes.innerHTML = discountCodesEl.innerHTML;
              this.onRemoveDiscounts();
            }
          });
      }

      handleError() {
        this.cartDiscountError && this.cartDiscountError.classList.add('show');
      }

      handleSuccessMessage() {
        this.cartDiscountSuccess && this.cartDiscountSuccess.classList.add('show');
      }
    }
  );
}